import { render, staticRenderFns } from "./ActivarEficienciasComponent.vue?vue&type=template&id=7a0f76d8&"
import script from "./ActivarEficienciasComponent.vue?vue&type=script&lang=js&"
export * from "./ActivarEficienciasComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
